module.exports = "<button mat-button class=sideBar>\n\t<span class=\"fill-space\">DNA</span>\n</button>\n<canvas #c class=\"mainCanvas\"></canvas>\n"